export const SUPPORTED_LOCALES = [
	"en",
	"cs",
	"sk",
]
export const LOCALE_STORAGE_KEY = process.env.REACT_APP_LOCALE_STORAGE_KEY
export const DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_LOCALE